import '@/public-path'
import { createApp } from 'vue'
import { setupPlugins } from '../utils/setup-plugins'
import { initLanguage } from '../utils/localize'
import { initTheme } from '@/utils/theme'
import '@/assets/css/tailwind/index.css'

declare global {
    interface HTMLElement extends Element {
        // eslint-disable-next-line camelcase
        __current_app: string | null;
        // eslint-disable-next-line camelcase
        __vue_app__: any | null;
        // eslint-disable-next-line camelcase
        __node: any | null;
    }

    interface Window {
      __appName: string | null
    }
}

const createVueApp = (appElement: any, appName: any, mount = true) => {
  const initApp = () => {
    initLanguage()
    initTheme()
    const app = createApp(appElement)

    setupPlugins(app, appName)

    return app
  }

  const commonChunkScript = document.querySelector('script[src*="chunk-common"]')

  if (commonChunkScript?.nextElementSibling) {
    const app = initApp()

    if (mount) {
      const appContainerId = 'app'
      const appContainer = document.getElementById(appContainerId)

      if (appContainer) {
        appContainer.remove()
      }
      const container = document.createElement('section')

      container.id = appContainerId
      document.body.insertBefore(container, document.body.firstChild)

      window.__appName = appName
      app.mount(container as HTMLElement)
    }

    return app
  }
}

export default createVueApp
